module.exports = __webpack_public_path__ + "img/image02_sp.b95416ee.jpg";